import constants from '../../constants';

const API_BASE = constants.baseApiHost;
const API_KEY = constants.apikey;

const getSession = () => {
  const raw = localStorage['session'];
  return raw && raw !== 'undefined' ? JSON.parse(raw) : null;
};

const getHeaders = (): Record<string, string> => {
  const session = getSession();
  return {
    ApiKey: API_KEY || '',
    'Content-Type': 'application/json',
    Authorization: session?.key ? `bearer ${session.key}` : ''
  };
};

const handleApiResponse = async (response: Response) => {
  if (!response.ok) {
    throw new Error(`API Error: ${response.status} ${response.statusText}`);
  }
  return response.json();
};

export const fetchCampaign = async (id: number | string) => {
  const response = await fetch(`${API_BASE}/api/v2/page/campaign/${id}`, {
    method: 'GET',
    headers: getHeaders()
  });
  const json = await handleApiResponse(response);
  return json?.data;
};
